import {
  NAV_GROUP_URL_MAP,
  type NavGroupType,
} from 'components/global/Nav/content';

export const isNavGroupActive = (
  currentPathname: string,
  navGroup: NavGroupType,
) => !!currentPathname.startsWith(`/${NAV_GROUP_URL_MAP[navGroup]}`);
